module.exports = __webpack_public_path__ + "assets/signOut.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/signOut.svg
// module id = 358
// module chunks = 0